export default __webpack_public_path__ + "static/media/7 Effective & Functional HIIT Workouts.ce3a6011.png";